import { m } from '@/paraglide/messages.js';
import { LocaleSelector } from '@/components/locale-selector';
import { SiteHeader } from '@/components/site-header';

export function Header() {
  return (
    <SiteHeader
      language={
        <LocaleSelector
          className="crt-language size-10 shrink-0"
          label={m['control.language.select']()}
        />
      }
      navLinks={[
        { href: '/build-planner', label: m['control.nav.planner']() },
        { href: '/puzzles', label: m['control.nav.puzzles']() },
        { href: '/abilities', label: m['control.nav.abilities']() },
        { href: '/quests', label: m['control.nav.quests']() },
        { href: '/trophies', label: m['control.nav.trophies']() },
      ]}
      cta={{ href: '/build-planner', label: m['control.open_planner']() }}
      menuLabels={{
        open: m['control.menu.open'](),
        close: m['control.menu.close'](),
        main: m['control.menu.main'](),
        mobile: m['control.menu.mobile'](),
      }}
    />
  );
}
